// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ResponsiveImage_imageContainer__uBXpc","image":"ResponsiveImage_image__VzFqa","rounded":"ResponsiveImage_rounded__9eQyZ"};